<template>
  <div class="blog-header">
    <div class="blog-header__container">
      <h1 class="blog-header__title">
        {{ _T(getPageName) }}
      </h1>
      <Navigation />
      <PopularTags
        v-if="!isRouteMatched(RouteNames.BLOG_POST)"
        :tags="useBlogStore().tags"
      />
    </div>
  </div>
  <RouterView />
</template>

<script setup>
import Navigation from "~/nuxt_modules/blog/ui/components/Navigation.vue";
import PopularTags from "~/nuxt_modules/blog/ui/pages/Blog/PopularTags.vue";
import { useBlogStore } from "~/nuxt_modules/blog/store/blog.store.js";
import { unlocalizeRouteName } from "~/utils/strings.utils";
import { isRouteMatched } from "~/utils/valueMatched";
import { RouteNames } from "~/nuxt_modules/common/config/route.config.js";

const route = useRoute();
const { fetchCategories, fetchTags, getCategory, getTag } = useBlogStore();

await Promise.all([fetchCategories(), fetchTags()]);

const pageNameMap = {
  [RouteNames.BLOG_HOME]: {
    name: () => "@Blog",
  },
  [RouteNames.BLOG_TAG]: {
    name: () => `#${getTag(route.params.tagSlug)?.name}`,
  },
  [RouteNames.BLOG_CATEGORY]: {
    name: () => getCategory(route.params.categorySlug)?.name,
  },
};

const getPageName = computed(() => {
  return pageNameMap[unlocalizeRouteName(route.name)]?.name();
});
</script>

<style scoped lang="scss">
.blog-header {
  padding: 16px;

  &__container {
    @extend %width-main;

    @include flex-container(column, flex-start);
    gap: 24px;

    margin-inline: auto;
  }

  &__title {
    @include font(34, 42, 600);

    @include mobile {
      @include font(22, 30, 600);
    }
  }
}
</style>
